import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["active", "selected", "Option", "onClick", "form", "element", "name", "option"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import t, { useEffect as H, useRef as w } from "react";
import { Combobox as c, Portal as V } from "@headlessui/react";
import { useLocationData as j } from "./use-location-data";
import { useSelectPopper as q } from "./use-select-popper";
var z = t.forwardRef(function (_ref, O) {
    var o = _ref.active,
      y = _ref.selected,
      b = _ref.Option,
      _ref$onClick = _ref.onClick,
      C = _ref$onClick === void 0 ? void 0 : _ref$onClick,
      r = _ref.form,
      s = _ref.element,
      p = _ref.name,
      u = _ref.option,
      l = _objectWithoutProperties(_ref, _excluded);
    return t.createElement(b, _objectSpread({
      $active: o,
      $selected: y,
      onClick: function onClick() {
        var f;
        r.setFieldState(p, {
          value: u
        }), (f = s == null ? void 0 : s.focus) == null || f.call(s), setTimeout(function () {
          var g = r.formSchema[p].focusOnNext;
          r.focusOn(g);
        }, 100);
      },
      ref: O
    }, l), u.label);
  }),
  Y = function Y(_ref2) {
    var o = _ref2.form,
      y = _ref2.menu,
      b = _ref2.menuContainer,
      C = _ref2.option,
      r = _ref2.inputComponent,
      s = _ref2.emptyOption,
      _ref2$debounceDelay = _ref2.debounceDelay,
      p = _ref2$debounceDelay === void 0 ? 500 : _ref2$debounceDelay,
      _ref2$selectOnClick = _ref2.selectOnClick,
      u = _ref2$selectOnClick === void 0 ? !0 : _ref2$selectOnClick,
      l = _ref2.name,
      O = _ref2.formatResults,
      _ref2$autoComplete = _ref2.autoComplete,
      T = _ref2$autoComplete === void 0 ? "off" : _ref2$autoComplete,
      f = _ref2.placeholder,
      g = _ref2.offset,
      h = _ref2.portal;
    var E;
    var k = (E = o == null ? void 0 : o.state) == null ? void 0 : E[l],
      _q = q({
        offset: g
      }),
      a = _q.element,
      v = _q.setElement,
      F = _q.setPopper,
      L = _q.styles,
      $ = _q.attributes,
      m = w(null),
      _j = j({
        debounceDelay: p,
        formatResults: O,
        name: l,
        form: o
      }),
      P = _j.loadOptions,
      B = _j.isLoading,
      x = _j.options,
      I = function I(n) {
        P.current(n.target.value);
      },
      N = function N(n) {
        o.setFieldState(l, {
          value: n
        }), setTimeout(function () {
          var d, S;
          var e = o.formSchema[l].focusOnNext;
          if (!e) return;
          if (o.formSchema[e].type === "location") return (S = (d = o.refs[e]) == null ? void 0 : d.current) == null ? void 0 : S.focus();
          o.focusOn(e);
        }, 50);
      },
      M = function M() {
        var n, e, i;
        (e = (n = m == null ? void 0 : m.current) == null ? void 0 : n.click) == null || e.call(n), u && ((i = a == null ? void 0 : a.select) == null || i.call(a));
      };
    H(function () {
      o.refs[l].current = a;
    }, [a]);
    var D = h || V;
    return t.createElement(c, {
      value: k.value,
      onChange: N
    }, function (_ref3) {
      var n = _ref3.open;
      return t.createElement(t.Fragment, null, t.createElement(c.Button, {
        style: {
          display: "none"
        },
        ref: m
      }), t.createElement(c.Input, {
        onFocus: M,
        displayValue: function displayValue(e) {
          return e == null ? void 0 : e.label;
        },
        onChange: I,
        ref: v,
        isLoading: B,
        as: r,
        placeholder: f,
        autoComplete: T,
        name: l,
        form: o
      }), t.createElement(D, null, t.createElement(c.Options, _objectSpread({
        as: b,
        ref: F,
        static: !0,
        style: _objectSpread(_objectSpread({}, L.popper), {}, {
          pointerEvents: n ? "" : "none"
        })
      }, $.popper), t.createElement(y, {
        open: n
      }, !x.length && (typeof s == "function" ? s() : t.createElement(C, {
        $disabled: !0
      }, s)), x.map(function (e) {
        return t.createElement(c.Option, {
          key: e.value,
          value: e,
          as: t.Fragment
        }, function (_ref4) {
          var i = _ref4.active,
            d = _ref4.selected;
          return t.createElement(z, {
            active: i,
            selected: d,
            option: e,
            Option: C,
            form: o,
            element: a,
            name: l
          }, e.label);
        });
      })))));
    });
  };
export { Y as LocationSelect };